<script setup lang="ts">
import { relsInjectKey } from "~~/helpers/injectKeys";
import type { BlokAppartementList } from "@/.storyblok/types/120421/storyblok-components";

const props = defineProps<{
  blok: BlokAppartementList;
}>();

const rels = inject(relsInjectKey, []);
</script>

<template>
  <div class="flex flex-col">
    <div
      v-for="appartement of rels"
      :key="appartement.id"
      class="flex-grow not-first:pt-1.5rem not-last:pb-1.5rem xs:not-first:pt-8 xs:not-last:pb-8 md:not-first:pt-10 md:not-last:pb-10 not-last:border-b border-solid"
    >
      <BaseAppartementReference
        :slug="appartement.full_slug"
        :appartement="appartement.content"
      ></BaseAppartementReference>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
